/* ================================================================
   TRIUNE WATCHES, theme.js
   Vanilla JS. No jQuery. No frameworks.
   ================================================================ */

(function() {
  'use strict';

  /* ----------------------------------------------------------------
     1. ACCORDION
     Toggle .is-open on click, update aria-expanded
     ---------------------------------------------------------------- */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.accordion__trigger');
    if (!trigger) return;

    var item = trigger.closest('.accordion__item');
    var isOpen = item.classList.contains('is-open');

    /* Close siblings (one-at-a-time per accordion) */
    var accordion = item.closest('.accordion');
    if (accordion) {
      accordion.querySelectorAll('.accordion__item.is-open').forEach(function(sibling) {
        if (sibling !== item) {
          sibling.classList.remove('is-open');
          sibling.querySelector('.accordion__trigger').setAttribute('aria-expanded', 'false');
        }
      });
    }

    item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });

  /* ----------------------------------------------------------------
     1b. FAQ ICON ITEMS (homepage FAQ teaser)
     Same one-at-a-time toggle pattern
     ---------------------------------------------------------------- */
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.faq-icon-item__trigger');
    if (!trigger) return;

    var item = trigger.closest('.faq-icon-item');
    var isOpen = item.classList.contains('is-open');

    var list = item.closest('.faq-icon-list');
    if (list) {
      list.querySelectorAll('.faq-icon-item.is-open').forEach(function(sibling) {
        if (sibling !== item) {
          sibling.classList.remove('is-open');
          sibling.querySelector('.faq-icon-item__trigger').setAttribute('aria-expanded', 'false');
        }
      });
    }

    item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });


  /* ----------------------------------------------------------------
     2. FADE-IN ON SCROLL (IntersectionObserver)
     Add class="fade-in" to any element to animate in.
     ---------------------------------------------------------------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var fadeObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    /* Product-page scroll reveal: auto-tag every Shopify section after the hero
       with .fade-in so the page reveals as the visitor scrolls. Skips the
       first section (hero / above-the-fold) so it renders immediately. */
    if (document.body.classList.contains('template-product')) {
      var REVEAL_CLASSES = ['fade-in', 'fade-in-left', 'fade-in-right', 'fade-in-scale', 'stagger-children'];
      var productSections = document.querySelectorAll('main .shopify-section, main > .shopify-section, body > main .shopify-section');
      var seen = {};
      productSections.forEach(function(el, i) {
        if (i === 0 || seen[el.id]) return;
        seen[el.id] = true;
        var hasReveal = REVEAL_CLASSES.some(function(c) { return el.classList.contains(c); });
        if (!hasReveal) el.classList.add('fade-in');
      });
    }

    document.querySelectorAll('.fade-in, .fade-in-left, .fade-in-right, .fade-in-scale, .stagger-children').forEach(function(el) {
      fadeObserver.observe(el);
    });
  }


  /* ----------------------------------------------------------------
     3. AJAX CART HELPERS
     Used by cart drawer for quantity changes and item removal
     ---------------------------------------------------------------- */
  var Cart = {
    update: function(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function(r) { return r.json(); });
    },

    get: function() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    },

    formatMoney: function(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents);
      }
      return '$' + (cents / 100).toFixed(2);
    },

    refreshDrawer: function(cart) {
      /* Update count badges */
      document.querySelectorAll('[data-cart-count]').forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      /* Update subtotal */
      var subtotalEl = document.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = Cart.formatMoney(cart.total_price);

      /* Toggle footer */
      var footer = document.querySelector('[data-cart-footer]');
      if (footer) footer.style.display = cart.item_count > 0 ? '' : 'none';

      /* Rebuild cart body */
      var body = document.querySelector('[data-cart-body]');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
        return;
      }

      var html = '';
      cart.items.forEach(function(item, i) {
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'
          : '';

        html += '<div class="cart-drawer__item" data-cart-item data-line="' + (i + 1) + '">'
          + '<a href="' + item.url + '" class="cart-drawer__item-image-wrap">'
          + (item.image ? '<img src="' + item.image + '" alt="" class="cart-drawer__item-image" width="80" height="80" loading="lazy">' : '')
          + '</a>'
          + '<div class="cart-drawer__item-details">'
          + '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>'
          + variantTitle
          + '<p class="cart-drawer__item-price">' + Cart.formatMoney(item.final_line_price) + '</p>'
          + '<div class="cart-drawer__item-qty">'
          + '<button class="cart-drawer__qty-btn" data-qty-change="-1" aria-label="Decrease">&minus;</button>'
          + '<span class="cart-drawer__qty-value" data-qty-value>' + item.quantity + '</span>'
          + '<button class="cart-drawer__qty-btn" data-qty-change="1" aria-label="Increase">&plus;</button>'
          + '</div></div>'
          + '<button class="cart-drawer__item-remove" data-remove-item aria-label="Remove">'
          + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1"/></svg>'
          + '</button></div>';
      });

      body.innerHTML = html;
    }
  };

  /* Quantity change */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;

    var item = btn.closest('[data-cart-item]');
    var line = parseInt(item.dataset.line);
    var qtyEl = item.querySelector('[data-qty-value]');
    var currentQty = parseInt(qtyEl.textContent);
    var delta = parseInt(btn.dataset.qtyChange);
    var newQty = Math.max(0, currentQty + delta);

    Cart.update(line, newQty).then(function(cart) {
      Cart.refreshDrawer(cart);
    });
  });

  /* Remove item */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-remove-item]');
    if (!btn) return;

    var item = btn.closest('[data-cart-item]');
    var line = parseInt(item.dataset.line);

    Cart.update(line, 0).then(function(cart) {
      Cart.refreshDrawer(cart);
    });
  });

  /* Close cart on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var drawer = document.querySelector('[data-cart-drawer].is-open');
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

})();
